<template>
  <div class="is-fullheight section">
    <b-loading :active="!loaded" />
    <div v-if="loaded" class="columns is-centered">

      <div class="column is-8">

        <h6 class="subtitle pb-0 is-6 has-text-centered">SPECIAL OFFER <span v-if="cbName">FOR {{cbName}}</span></h6>
        <h3 class="title has-text-centered is-3 has-text-primary">{{title}}</h3>

        <div class="box">
          <h4 class="title is-4">{{capper.title}}</h4>

          <div class="content">
            <p>{{capper.copy}}</p>
          </div>

          <h4 v-if="pendingPicks.length" class="title is-4">{{pendingPicksLabel}}</h4>

          <div v-for="(pick, i) in pendingPicks"
               :key="`pick-${pick.id}`"
               :class="`${pickWrapperClasses(i === pendingPicks.length - 1)} mb-6`">
            <pending-pick :pick="pick" :column-classes="pickColumnClasses()" :should-obscure-match-up="capper.obscurePending" />
          </div>

          <div v-if="record.length" class="mb-5">
            <h4 class="title is-4">
              {{recordLabel}}:
              <strong class="has-text-weight-bold">
                {{recordWins}} - {{recordLosses}} {{ recordPushes ? ` - ${recordPushes}` : ''}}
              </strong>
            </h4>

            <div class="table-container">
              <table class="table is-fullwidth is-striped is-hoverable is-narrow">
                <thead>
                <tr>
                  <th class="is-size-5">Date</th>
                  <th class="is-size-5">Result</th>
                  <th class="is-size-5">Wager</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="wager in record" :key="`record-${wager.id}`">
                  <td class="is-size-5">{{ wager.date.split('/').slice(0, 2).join('/') }}</td>
                  <td :class="`is-size-5 ${wager.isWinner ? 'has-text-weight-bold' : ''}`">
                    {{ isWinLossOrPush(wager.isWinner) }}
                  </td>
                  <td>
                    <span class="is-size-6">{{ wager.awayTeam }}<br/>{{wager.homeTeam}}</span>
                    <br/>
                    <strong class="is-size-5">{{wager.pick}}</strong></td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

          <UpSaleBtns :cbfid-item="capper.cbfidItem"
                      :price="capper.cbfidPrice"
                      :terms="capper.cbfidTerms"
                      :duration="capper.cbfidDuration"
                      :vendor="capper.cbfidVendor"
                      :service-links="capper.paymentLinks" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getUpSell } from '@/utils/api';
import {pickWrapperClasses, pickColumnClasses, adjustTSSRiskAmounts} from '@/utils/misc';
import PendingPick from '@/components/members/PendingPick';
import UpSaleBtns from '@/components/misc/UpSaleBtns';

export default {
  components: {
    PendingPick,
    UpSaleBtns
  },
  data() {
    return {
      title: process.env.VUE_APP_US_TITLE || 'Recommended Addition To Your Order',
      loaded: false,
      capper: null,
      pendingPicksLabel: process.env.VUE_APP_UPCOMING_PICKS_LABEL || 'Upcoming Picks',
      pendingPicks: [],
      record: [],
      recordLabel: process.env.VUE_APP_RECENT_RESULTS_LABEL || 'Recent Results',
      cbName: ''
    }
  },
  mounted() {
    let { query } = this.$route;
    let { cbfid, cname } = query;
    let cbfidSlug = this.$route.params.cbfid;
    let flowId = cbfidSlug || cbfid;

    if (cname) {
      this.cbName = cname;
    }

    if (!flowId) {
      return this.handleFailure({flowId, query, res: {}});
    }

    getUpSell({flowId})
      .then(async res => {
        if (!res.ok) {
          return this.handleFailure({flowId, query, res})
        }

        this.capper = await res.json();

        this.record = this.capper.r;

        let pending = this.capper.isTSS ? this.adjustTSSRiskAmounts(this.capper.pending) : this.capper.pending;

        this.pendingPicks = pending.filter(pick => {
          let isClosedPick = pick.dateTime < new Date().getTime();
          let shouldHide = this.capper.hideClosedPicks;

          console.log({shouldHide, isClosedPick, retVal: shouldHide ? !isClosedPick : true});

          return shouldHide ? !isClosedPick : true;
        });
      })
      .finally(() => this.loaded = true)
      .catch(err => {
        this.handleFailure({flowId, query, res: err})
      });
  },
  methods: {
    handleFailure: function ({flowId, query, res}) {
      alert(`Failure: CBFID=${flowId}, QUERY=${JSON.stringify(query)}, RES=${res.status}: ${res.statusText}`);
      console.log({flowId, query, res});
    },
    pickWrapperClasses: pickWrapperClasses,
    pickColumnClasses: pickColumnClasses,
    adjustTSSRiskAmounts: adjustTSSRiskAmounts,
    isWinLossOrPush: function (result) {
      if (result === true) {
        return 'WIN';
      }

      if (result === false) {
        return 'Loss';
      }

      return 'Push'
    }
  },
  computed: {
    recordWins: function () {
      return this.record.filter(wager => wager.isWinner).length;
    },
    recordLosses: function () {
      return this.record.filter(wager => wager.isWinner ===  false).length;
    },
    recordPushes: function () {
      return this.record.filter(wager => wager.isWinner !== true && wager.isWinner !== false).length;
    }
  }
}
</script>

<style scoped>

</style>